import { FaBug, FaSync } from 'react-icons/fa';
import { Button } from '@/components/UI';

interface AuditActionButtonsProps {
    actionPending: boolean;
    populateLedgerPending: boolean;
    runAuditPending: boolean;
    onPopulateLedger: () => void;
    onRunAudit: () => void;
}

const AuditActionButtons = ({
    actionPending,
    populateLedgerPending,
    runAuditPending,
    onPopulateLedger,
    onRunAudit
}: AuditActionButtonsProps) => (
    <div className="flex flex-wrap gap-2">
        <Button
            className="inline-flex items-center"
            disabled={actionPending}
            icon={<FaSync />}
            isLoading={populateLedgerPending}
            size="sm"
            variant="secondary"
            onClick={onPopulateLedger}
        >
            {populateLedgerPending ? 'Refreshing...' : 'Refresh Audit Status'}
        </Button>
        <Button
            className="inline-flex items-center"
            disabled={actionPending}
            icon={<FaBug />}
            isLoading={runAuditPending}
            size="sm"
            variant="secondary"
            onClick={onRunAudit}
        >
            {runAuditPending ? 'Running Audit...' : 'Run Audit'}
        </Button>
    </div>
);

export default AuditActionButtons;
